import React, { useEffect, useState } from 'react';

import useEventCallback from '../useEventCallback/index.ts';

/**
 * Allows the component to be responsible for its own input state
 * but delegates responsibility to the parent if the parent passes valueFromProps
 * */
export default function useQuickValue(
  valueFromProps: string,
  onChange: React.ChangeEventHandler<HTMLInputElement>
  // Make this an onchange event handler
): [string, React.ChangeEventHandler<HTMLInputElement>] {
  const [value, setValue] = useState(valueFromProps);
  // NP needed to respond both synchronously and asynchronously
  // https://stackoverflow.com/questions/28922275/in-reactjs-why-does-setstate-behave-differently-when-called-synchronously/28922465#28922465
  const [shouldUseInternalState, setShouldUseInternalState] = useState(true);
  const handleInputChange = useEventCallback(e => {
    setValue(e.target.value);
    // NP In response to an input event always use the internal state
    setShouldUseInternalState(true);
    onChange(e);
  });
  useEffect(() => {
    if (value !== valueFromProps) {
      // NP If internal state and props are not equal always use the props
      setShouldUseInternalState(false);
    }
  }, [value, valueFromProps]);

  return [shouldUseInternalState ? value : valueFromProps, handleInputChange];
}
